/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * A minted per-user API key for the device agent.
 */
export type TokenResult = {
  /**
   * The raw per-user API key (carries the `agent_user` scope). Returned exactly once; store it securely. Presented as the Gram-Key on downstream user-scoped endpoints.
   */
  accessToken: string;
  /**
   * Always zero. The minted key has no expiry (api_keys has no TTL).
   */
  expiresIn: number;
  /**
   * Always empty. The minted key is long-lived and does not refresh; its lifecycle lever is revocation.
   */
  refreshToken: string;
  /**
   * Email the key was minted for.
   */
  userEmail: string;
};

/** @internal */
export const TokenResult$inboundSchema: z.ZodMiniType<TokenResult, unknown> = z
  .pipe(
    z.object({
      access_token: z.string(),
      expires_in: z.int(),
      refresh_token: z.string(),
      user_email: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        "access_token": "accessToken",
        "expires_in": "expiresIn",
        "refresh_token": "refreshToken",
        "user_email": "userEmail",
      });
    }),
  );

export function tokenResultFromJSON(
  jsonString: string,
): SafeParseResult<TokenResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => TokenResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'TokenResult' from JSON`,
  );
}
